module.exports = __webpack_public_path__ + "static/media/faq_memo.b4eea5e8.jpg";